module.exports = __webpack_public_path__ + "bg-8.85f039d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./mysite/resources/images/bg-8.jpg
// module id = ./mysite/resources/images/bg-8.jpg
// module chunks = main